'use strict';

import $ from 'jquery';
import Backbone from 'backbone';
import * as config from '../../js/config';
import newsletterSignUpSuccessTemplate from './templates/_NewsletterSignUpSuccess.hbs';

class NewslettersView extends Backbone.View {
  events() {
    return {
      'click [name=Newsletters-subscribe]': 'onNewsletterSignUp',
      'click .Newsletters-continue-shopping': 'onContinueShopping'
    };
  }

  initialize() {
    this.$rightContainer = $('.Newsletters-rightContainer', this.$el);
    this.$form = $('form', this.$el);
    this.$formError = $('.Newsletters-signup-fail', this.$el);
    this.$subscribeBtn = $('[name=Newsletters-subscribe]', this.$el);
  }

  onContinueShopping() {
    window.location.href = '/';
  }

  onNewsletterSignUp(e) {
    e.preventDefault();
    if (!this.$form.valid()) {
      return;
    }

    this.toggleSignupError(false);
    this.toggleNewsletterSignUpLoading(true);

    this.newsletterSignUp()
      .done(() => {
        this.onNewletterSignupSuccess();
      })
      .fail((jqXHR, textStatus, errorThrown) => {
        this.onNewletterSignupError(errorThrown);
      })
      .always(() => {
        this.toggleNewsletterSignUpLoading(false);
      });
  }

  newsletterSignUp() {
    const eloquaUrl = this.$form.prop('action');
    const formData = this.$form.serialize();

    return $.ajax(eloquaUrl, {
      contentType: 'application/x-www-form-urlencoded',
      method: 'POST',
      data: formData
    });
  }

  onNewletterSignupSuccess() {
    this.$rightContainer.html(newsletterSignUpSuccessTemplate());
  }

  onNewletterSignupError() {
    this.toggleSignupError(true);
  }

  toggleSignupError(display) {
    if (display) {
      this.$formError.removeClass(config.classes.uHide);
      return;
    }

    this.$formError.addClass(config.classes.uHide);
  }

  toggleNewsletterSignUpLoading(display) {
    if (display) {
      this.$subscribeBtn.addClass(config.classes.loadingClass);
      return;
    }

    this.$subscribeBtn.removeClass(config.classes.loadingClass);
  }
}

const createNewsletters = ($parent) => {
  const $newsletter = $parent.find('.Newsletters');

  if ($newsletter.length) {
    return new NewslettersView({ el: $newsletter });
  }
};

export { createNewsletters, NewslettersView };


// WEBPACK FOOTER //
// ./assets/components/Newsletters/NewslettersView.js